import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkEditApi extends BaseClient {
  public doExternalLinkEdit (id: string, bodyData: any) {
    const path:string = '/v1/external-links/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new ExternalLinkEditApi()
